import { StyleSheet } from 'aphrodite';
import { THEME } from '../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	userGroupsContainer: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'center',
		gap: 4,
		marginTop: 8,
	},
	userGroupsLabel: {
		fontSize: 11,
		color: THEME.colors.text.light,
		marginRight: 2,
		flexShrink: 0,
	},
});
